// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18zr1ejb{padding-inline:var(--ds-space-300,24px)}\n._1bah1yb4{justify-content:space-between}\n._1e0c1txw{display:flex}\n._1q511ejb{padding-block-start:var(--ds-space-300,24px)}\n._4cvr1h6o{align-items:center}\n._6rth1i6y{margin-block-end:var(--ds-space-negative-025,-2px)}\n._85i5pxbi{padding-block-end:var(--ds-space-200,1pc)}\n._kqswh2mm{position:relative}", ""]);
// Exports
module.exports = exports;
